import { Injectable } from '@angular/core';

/**
 * Contiene rutinas y funciones relacionadas directamente con las tareas del administrador
 */
@Injectable()
export class AdminService {

    // -----------------------------------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------------------------------
    constructor() { }



}



// WEBPACK FOOTER //
// ./src/app/services/admin/admin.service.ts